import { Fragment } from "react";
import { Colors, invertDark } from "../Assets/Config/color.config";
import "../App.css";
import { inject, observer } from "mobx-react";
import "../config"
import { colorTheme, colorTheme_Label, colorTheme_TextField, invertDarkTheme } from "../Style/ColorTheme/colorTheme";

const color_Theme = colorTheme();
const invertDark_Theme = invertDarkTheme();
const placeHolder_color = colorTheme_TextField();
const label_color = colorTheme_Label();

export const MyInput = inject("store")(
  observer((props) => {
    const { theme, isBlueOnion } = props.store.common;
    const {
      isTextArea,
      style,
      placeHolder,
      disabled,
      required,
      type,
      id,
      height,
      width,
      onChange,
      value,
      maxLength,
      pattern,
      myRef,
      customcolor,
      _handleView,
      autoComplete,
      visible,
      label,
      min,
      max,
      onKeyDown,
      icon,
      unit,
      unitMax,
      mandatory,
      labelColor
    } = props;
    // const theme = localStorage.getItem("theme");
    const defaultStyle = {
      width: width === undefined ? "100%" : width,
      // background:theme==='dark'&&Colors.darkBlue,
      color: disabled ? color_Theme.disabledText :  label_color(theme),
      paddingTop: 10,
      paddingBottom: 10,
      fontSize: 14,
      height: height,
      boxShadow: "none",
      shapeOutline: "none",
      outline: "none",
      border: `1px solid ${theme === 'dark' ? color_Theme.dark.textFieldBorder : color_Theme.light.textFieldBorder}`,
      borderRadius: 5,
      background: Colors[theme].secondBackground,
      fontFamily: color_Theme.fontFamily,
      fontWeight:500,
    };
    const disabledStyle = {
      background: customcolor,
    };
    // const defaultStyle1=disabled && disabledStyle
    const userStyle = style === undefined ? {} : style;

    const __handleFocus = () => {
      document.getElementById(
        id
      ).style.border = `2px solid ${Colors["dark"].primaryColor}`;
    };
    const __handleBlur = () => {
      document.getElementById(
        id
      ).style.border = `2px solid ${Colors["dark"].secondaryColor}`;
    };
    const percentageIcon ={
       marginLeft:"86%", 
       transform:"translateY(-30%)",
       paddingBottom:"96px", 
       position:"absolute"   
    };

    const unitStyles ={
      right:10,
      top: "50%",
      transform: "translateY(-50%)",
      position:"absolute"   
   };
   const unitStylePadding = {
    paddingRight:unitMax ? 120 : 50
   }
    // 
    return (
      <Fragment>
        {label && (
        <>
        {mandatory ?
          <span
          style={{
            color: "red",
            fontSize: "16px",
            marginTop: "14px",
          }}
          >
            *
          </span> : null}
        <label style={{ fontSize: 14, padding: '2px', color: labelColor  ? labelColor :invertDark_Theme(theme) , fontFamily: color_Theme.fontFamily,}}>{label} :</label>
        </>)
        }
        <div style={{position:"relative"}}>
        {isTextArea === undefined ? (<input
          ref={myRef}
          spellCheck="false"
          autoComplete={autoComplete}
          id={id}
          disabled={disabled}
          required={required}
          onChange={onChange}
          onKeyDown={onKeyDown}
          style={{
            ...defaultStyle,
            // ...defaultStyle1,
            ...userStyle,
            ...(unit ? unitStylePadding : null)
          }}
          onBlur={__handleBlur}
          pattern={pattern ? pattern : null}
          placeholder={placeHolder}
          className={isBlueOnion === "true" ?"form-control input-placeholder": "form-control default-placeholder"}
          onFocus={__handleFocus}
          type={visible ? "text" : type}
          value={value != null ? value : ""}
          maxLength={maxLength}
          min={min}
          max={max}
        />)
          : (
            <textarea
              spellCheck="false"
              id={id}
              disabled={disabled}
              required={required}
              onChange={onChange}
              onKeyDown={onKeyDown}
              style={{
                ...defaultStyle,
                // ...defaultStyle1,
                ...userStyle,
              }}
              onBlur={__handleBlur}
              pattern={pattern ? pattern : null}
              placeholder={placeHolder}
              className={isBlueOnion === "true" ?"form-control input-placeholder": "form-control default-placeholder"}
              onFocus={__handleFocus}
              type={visible ? "text" : type}
              value={value != null ? value : ""}
            />
          )
        }
        {placeHolder === "Allocation" && (
            <span style={{...percentageIcon}}>%</span>
          )}
          {
            unit && (<span style={{...unitStyles}}>{unit}</span>)
          }
          </div>
        {
          icon && (<span
            style={{
              float: "right",
              position: "relative",
              marginTop: "-35px",
              fontSize: "18px",
              marginRight: "15px",
              cursor: "pointer",
            }}
            // onClick={() => _handleView()}
          >
           {icon}
          </span>)
        }
        {type === "password" && (
          <span
            style={{
              float: "right",
              position: "relative",
              marginTop: "-35px",
              fontSize: "18px",
              marginRight: "20px",
              cursor: "pointer",
            }}
            onClick={() => _handleView()}
          >
            <i
              className={`bi bi-eye${!visible ? "-slash" : ""
                } py-4 text-secondary`}
            />
          </span>
        )}
      </Fragment>
    );
  })
);
